export const environment = {
  production: true,
  airlineLogoUrl: 'https://storage.googleapis.com/test-tcat-static-assets/images/airlinelogos/{}.png',
  baseUrl: 'https://api.regtest.tcat.app',
  portalVersion: '1.1.0',
  api: {},
  cdn: {
    images: {
      baseUrl: ''
    }
  },
  mapUrl: 'https://maps.googleapis.com/maps/api/geocode/json',
  mapApiKey: 'AIzaSyBbka-kGSQkO5nJx4Nn4yKCRW_E9LIkLTE',
  placeDetailWidgetEnabled: false
};
